import React from "react";
import "./app.css";
const ArabicTerms = ({ cardData, activetab }) => {
  return (
    <div>
      <div className="card-body"></div>
      <div
        style={{
          border: "1px solid black",
          padding: "50px",
          margin: "10px",
          borderRadius: "10px",
        }}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: cardData?.arabic_description,
          }}
        />
      </div>
    </div>
  );
};

export default ArabicTerms;
